import { Origin } from '../enums';
export var configuration = {
    sessionStorageKeyPrefix: 'l3',
    sessionStorageKeySuffixes: {
        firstName: 'firstName',
        mobileNumber: 'mobileNumber',
        email: 'email',
        brokerId: 'brokerId',
        storeId: 'storeId',
    },
    brokerStorePageLeadJourneys: [Origin.AppointmentBooking, Origin.Refinance, Origin.NewHomeLoan, Origin.BorrowingPower],
    defaultTimezone: 'Australia/Sydney',
};
export default configuration;
//# sourceMappingURL=index.js.map